import type { UserRole } from "@/store/auth";

/**
 * Single source of truth for the user-facing label of each role. Anywhere
 * the UI renders a role name, import this map instead of writing inline
 * ternaries like `role === "admin_user" ? "Admin" : "Driver"` — those
 * silently misclassify route_manager (it would fall through to "Driver").
 */
export const ROLE_LABEL: Record<UserRole, string> = {
  admin_user: "Admin",
  route_manager: "Route Manager",
  app_user: "Driver",
};

/**
 * True for roles with elevated team-level powers (admin OR route manager).
 * Mirrors DB-level `is_admin()` from migration 0019. Use this instead of
 * checking `role === "admin_user"` when you mean "can manage the team".
 */
export function roleIsElevated(role: UserRole | undefined): boolean {
  return role === "admin_user" || role === "route_manager";
}
